import cardPlaceholder from './images/card-placeholder.png';
import visa from './images/visa.png';
import mastercard from './images/Mastercard.png';
import amex from './images/Amex.png';
import discover from './images/Discover.png';
import diners from './images/Diners.png';
import jcb from './images/JCB.png';

export const getCardPicByType = (cardType: string) => {
    switch (cardType) {
        case 'VISA':
            return visa;
        case 'MASTERCARD':
            return mastercard;
        case 'AMEX':
            return amex;
        case 'DISCOVER':
            return discover;
        case 'DINERS':
            return diners;
        case 'JCB':
            return jcb;
        default:
            return cardPlaceholder;
    }
};
